import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
  delete_icon,
  eye_view,
  Search_icon,
  view_icon,
} from "../../assets/img";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { get, patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../components/Table/Table";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";
import ReadNotificationPopup from "../../components/ReadNotificationPopup";
import UnReadNotificationPopup from "../../components/UnReadNotificationPopup";
import VowReview from "../../components/Review/VowReview";

const Review = () => {
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname, state } = useLocation();
  const path = pathname?.replace("/", "");
  let listOptions = ["Requested", "Active", "Deactivate", "Complaints", "Vow Review"];
  const [activeStatus, setActiveStatus] = useState(
    state?.tab ?? paginationData?.[path]?.tab ?? "Requested",
  );
  const [complaintTab, setComplaintTab] = useState(state?.complaintTab ?? "Not Responded");
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [submissionDescription, setSubmissionDescription] = useState("");
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  console.log("prop data", state);
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [popup, setPopup] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]
      ? { ...paginationData?.[path] }
      : {
          from: "",
          to: "",
          city: "",
          state: "",
          search: "",
          user: "",
          unread_only: false,
        },
  );
  const [totalCount, setTotalCount] = useState({
    Requested: 0,
    Active: 0,
    Deactivate: 0,
    Complaints: 0,
    "Vow Review": 0,
  });
  const [list, setList] = useState({
    Requested: [],
    Active: [],
    Deactivate: [],
    Complaints: [],
  });
  const [optionsList, setOptionsList] = useState({
    users: [],
    cities: [],
    states: [],
  });

  useEffect(() => {
    // console.log("pagination data called", paginationData, page, pagination);
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: page, ...selectedFilter ,tab:activeStatus},
    }));
  }, [
    selectedFilter.city,
    selectedFilter.state,
    selectedFilter.search,
    selectedFilter.user,
    page,
    activeStatus,
    complaintTab,
    selectedFilter?.unread_only,
  ]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  //cities with properties list
  const getFilters = async () => {
    const res = await get(URLS.REVIEW_FILTERS);
    console.log("review Filters", res);
    if (res?.status === "success") {
      let cities = res?.cities?.map((item) => ({
        value: item?.id,
        label: item?.name,
      }));
      let states = res?.states?.map((item) => ({
        value: item?.id,
        label: item?.name,
      }));
      let users = res?.users?.map((item) => ({
        value: item?.id,
        label: item?.name,
      }));
      setOptionsList({ cities: cities, states: states, users: users });
    }
  };

  useEffect(() => {
    getFilters();
  }, []);

  const getList = async (pageNumber = 1) => {
    // Vow Review has its own component (API not integrated yet)
    if (activeStatus === "Vow Review") return;
    const { city, from, state, search, to, user, unread_only } = selectedFilter;
    const payload = new FormData();
    let status =
      activeStatus === "Requested" ? 1 : activeStatus === "Active" ? 2 : activeStatus === "Deactivate" ? 3 : "";
    if (status) {
      payload.append("status", status);
    }
    if (activeStatus === "Complaints") {
      payload.append("has_complaint", 1);
      payload.append("complaint_status", complaintTab === "Not Responded" ? "Pending" : "Resolved");
    }
    if (search) {
      payload.append("search", search);
    }
    if (from && to) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (state) {
      payload.append("state", state?.value);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (user) {
      payload.append("user_id", user?.value);
    }
    let query;
    if (activeStatus === "Requested") {
    }
    const res = await post(
      URLS.REVIEW_LIST +
        "?page=" +
        pageNumber +
        (activeStatus === "Requested" ? "&unread_only=" + unread_only : ""),
      payload,
    );

    // const res = await post(
    //   URLS.REVIEW_LIST + "?page=" + pageNumber + activeStatus === "Requested"
    //     ? "&unread_only=" + unread_only
    //     : "",
    //   payload,
    // );
    // console.log("Review active status", res,);
    if (res?.status === "success") {
      let finalData = res?.data || [];
      if (activeStatus === "Complaints") {
        finalData = finalData.filter((item) => {
          if (item.has_complaint !== "yes") return false;
          const targetStatus = complaintTab === "Not Responded" ? "Pending" : "Resolved";
          return item.complaint_reviews?.some((c) => c.status === targetStatus);
        });
      }

      setTotalCount((prev) => ({
        ...prev,
        [activeStatus]: activeStatus === "Complaints" ? finalData.length : res?.count,
      }));
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList((prev) => ({ ...prev, [activeStatus]: finalData }));
    }
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                flexDirection: "row-reverse",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
              {row?.original?.has_unread_notification &&
                activeStatus === "Requested" && (
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleCheckboxChange}
                    style={{ width: 20, height: 20, marginTop: 9 }}
                  />
                )}
              {!row?.original?.has_unread_notification &&
                activeStatus === "Requested" && (
                  <img
                    src={eye_view}
                    style={{ width: 20, height: 20, marginTop: 5 }}
                    onChange={() => {
                      setIsViewDetails((prev) => ({
                        ...prev,
                        ispopUp: true,
                        details: row?.original,
                      }));
                    }}
                    onClick={() => {
                      setIsViewDetails((prev) => ({
                        ...prev,
                        ispopUp: true,
                        details: row?.original,
                      }));
                    }}
                  />
                )}
            </div>
          );
          // const pageSize = 10;
          // return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
        // Cell: ({ value, row }) => {
        //   return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        // },
      },

      {
        Header: " Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap ">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.property_code}</p>
            </div>
          );
        },
      },
      {
        Header: " Owner Name",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap ">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.owner_id}</p>
            </div>
          );
        },
      },

      {
        Header: "User Name",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap ">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.user_id}</p>
            </div>
          );
        },
      },
      {
        Header: " Property Location",
        accessor: "city",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">{`${value},${row.original?.state}`}</p>
          );
        },
      },
      {
        Header: "Star",
        accessor: "rating",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{`${value.toFixed(1)} ⭐️`}</p>;
        },
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ value, row }) => {
          return (
            <p
              style={{
                width: "150px",
                paddingRight: "10px",
                paddingLeft: "10px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordBreak: "break-word",
               
              }}
              className="text-wrap"
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Helped on Vow",
        accessor: "has_complaint",
        Cell: ({ value, row }) => {
          return <p style={{justifyContent:"center",alignItems:"center",display:"flex"}}>{value === "yes" ? "Yes" : "No"}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <button
              onClick={() => {
                if (value !== 1 && checkPermission("CAN-EDIT-REVIEW"))
                  handleStatus(row.original);
              }}
              className={`${
                value === 2 ? "active-btn" : "deactive-btn"
              } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
            >
              {value === 1 ? "Requested" : value === 2 ? "Active" : "Deactive"}
            </button>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/reviewview", {
                    state: { type: "request", data: row.original },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>

              {/* <button onClick={() => setPopup(true)} className="cust-btn ">
                  <img src={delete_icon} alt="" className=" edit-btn " />
                </button> */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-REVIEW") ? [...d, action] : d;
  }, [page, activeStatus, selectedOwners]);

  const handleStatus = async ({ id, status }) => {
    const payload = {
      review_id: id,
      status: status === 2 ? 3 : 2,
    };

    const res = await post(URLS.REVIEW_STATUS, payload);
    console.log("review status", res);
    if (res?.status === "success") {
      toast.success(
        `Review ${status === 2 ? "Deactivated" : "Activated"} Successfully`,
      );
      if (list[activeStatus]?.length === 1 && page !== 1)
        setPage((prev) => prev - 1);
      else getList(page);
    }
  };
  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);
      if (res?.status === "success") {
        // console.log("Description:", submissionDescription);
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };
  return (
    <div>
      <Topbar header={"Review"} />
      <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{totalCount?.[activeStatus] ?? 0}
        </h2>
        {activeStatus === "Requested" && (
          <div className="d-flex" style={{ alignItems: "center" }}>
            <input
              type="checkbox"
              checked={selectedFilter?.unread_only}
              onChange={() =>
                handleChangeFilter("unread_only", !selectedFilter?.unread_only)
              }
            />{" "}
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ">
              Check New Notification
            </p>
            {/* <Select
            className="location-search"
            options={[{ label: "New to Old", value: "newtoold" }]}
            isClearable
            // onChange={(e) => {
            //   handleChangeFilter("property", e);
            // }}
            // value={selectedFilter?.property}
            placeholder={"property"}
          /> */}
          </div>
        )}
        {listOptions?.map((item) => (
          <button
            key={item}
            onClick={() => {
              setPage(1);
              handleChangeFilter("from", "");
              handleChangeFilter("to", "");
              setActiveStatus(item);
            }}
            className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
              activeStatus === item ? "active-btn1" : "inactive-btn"
            }`}
          >
            {item}
          </button>
        ))}
        {activeStatus === "Complaints" && (
          <div className="d-flex w-100 mt-2 gap-3">
            <button
              onClick={() => {
                setPage(1);
                setComplaintTab("Not Responded");
              }}
              className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                complaintTab === "Not Responded" ? "active-btn1" : "inactive-btn"
              }`}
            >
              Not Responded
            </button>
            <button
              onClick={() => {
                setPage(1);
                setComplaintTab("Responded");
              }}
              className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${
                complaintTab === "Responded" ? "active-btn1" : "inactive-btn"
              }`}
            >
              Responded
            </button>
          </div>
        )}
      </div>
      {activeStatus === "Vow Review" ? (
        <VowReview
          setTotal={(n) =>
            setTotalCount((prev) =>
              prev["Vow Review"] === n ? prev : { ...prev, "Vow Review": n },
            )
          }
        />
      ) : (
        <>
      <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
        <DateRange
          fromValue={selectedFilter.from}
          toValue={selectedFilter.to}
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={optionsList?.states}
          placeholder={"State"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("state", e);
          }}
          value={selectedFilter?.state}
        />
        <Select
          className="location-search"
          options={optionsList?.users}
          placeholder={"User ID"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("user", e);
          }}
          value={selectedFilter?.user}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
      </div>
      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2 "
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list[activeStatus] || []}
        show={true}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
      />
        </>
      )}

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
      {showSubmitPopup && (
        <ReadNotificationPopup
          setSubmissionDescription={setSubmissionDescription}
          setShowSubmitPopup={setShowSubmitPopup}
          submissionDescription={submissionDescription}
          handleSumbit={handleSumbit}
        />
      )}
      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default Review;
